
import React, { useContext } from 'react';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
const AprovacaoFaturamentoDireto = () => {
  const { demandaData } = useContext(QuestionarioContextProvider);

  const renderizarMensagem = () => {
    switch (demandaData && demandaData.statusCodigo) {
      case EStatusDemanda.AguardandoGerenteDepartamento:
        return 'Sua demanda será validada pelo Gerente de Departamento.';
      case EStatusDemanda.AguardandoGerenteGeral:
        return 'Sua demanda será validada pelo Gerente Geral.';
      case EStatusDemanda.Cancelada:
        return 'Sua demanda foi cancelada.';
      case EStatusDemanda.Concluido:
        return 'Sua demanda foi concluída com sucesso.';
      default:
        return 'Sua demanda está em andamento.';
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <h3 style={{ color: 'rgb(105,105,105)' }}>
        {renderizarMensagem()}
      </h3>
    </div>
  );
};

export default AprovacaoFaturamentoDireto;
